import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import "./index.css";
import "./i18n"; // i18n initialization (must be before App)
import { installChunkErrorRecovery } from "./lib/chunkErrorRecovery";

import App from "./App";
import store from "./store";

import { Provider } from "react-redux";
import { ProSidebarProvider } from "react-pro-sidebar";
import { HelmetProvider } from "react-helmet-async";
import { AlertProvider } from "./contexts/AuthContext";

installChunkErrorRecovery();

const muiTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#09090b",
      paper: "#18181b",
    },
    text: {
      primary: "#fafafa",
      secondary: "#a1a1aa",
    },
    primary: { main: "#d4d4d8" },
    divider: "rgba(255, 255, 255, 0.08)",
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: [
      '"IBM Plex Sans"',
      "ui-sans-serif",
      "system-ui",
      "sans-serif",
    ].join(","),
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: '"IBM Plex Sans", sans-serif',
          backgroundColor: "#09090b",
          color: "#fafafa",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 500 },
      },
    },
  },
});

const rootEl = document.getElementById("root")!;

const tree = (
  <React.StrictMode>
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <ProSidebarProvider>
        <BrowserRouter>
          <Provider store={store}>
            <HelmetProvider>
              <AlertProvider>
                <App />
              </AlertProvider>
            </HelmetProvider>
          </Provider>
        </BrowserRouter>
      </ProSidebarProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// react-snap pre-renders static HTML for each route at build time.
// At runtime, hydrate the existing DOM if pre-rendered markup is
// present, otherwise mount fresh. The marker is the presence of any
// non-empty children — react-snap fills #root with the rendered tree.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}
